var map = {
	"./AB_Deutsch_Englisch.mp3": "9526",
	"./Buchteaser_Jugendroman.mp3": "441a",
	"./Dokumentation_Elefanten.mp3": "bd68",
	"./Dokumentation_Universum.mp3": "bacb",
	"./Erklärvideo.mp3": "931c",
	"./Hörbuch.mp3": "03f8",
	"./Imagefilm.mp3": "6c11",
	"./Stimmfarben_und_Akzente.mp3": "9726",
	"./Synchron_aufgebracht.mp3": "a563",
	"./Synchron_aufgewühlt_panisch.mp3": "c6ef",
	"./Synchron_bestimmt_stark.mp3": "724f",
	"./Synchron_psycho.mp3": "f85e",
	"./Voice_Over.mp3": "d935",
	"./Werbung_Creamy_Chocolate.mp3": "8f20",
	"./Werbung_LG.mp3": "e496",
	"./Werbung_Leiner.mp3": "5a24",
	"./Werbung_Max_Factor.mp3": "55ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fa7";